// Mock data for the Our Franchise page

export const franchiseData = {
  heroImage: "https://customer-assets-v7afamib.emergentagent.net/job_appa-playtime/artifacts/4h2c77vd_03.png",
  heroBadges: [
    { icon: "Award", title: "Premium Brand", desc: "An EBG Group\nventure" },
    { icon: "TrendingUp", title: "High Growth", desc: "India's growing\ntoy industry" },
    { icon: "Handshake", title: "Hands-On Support", desc: "End-to-end guidance\nat every step" },
    { icon: "BadgeIndianRupee", title: "Founding Advantage", desc: "Early partners get\nprime territories" },
  ],
  whyPartner: [
    { icon: "Tag", title: "A Brand Built with Love", desc: "A fresh, family-inspired brand crafted for Indian kids and parents." },
    { icon: "TrendingUp", title: "High Growth Industry", desc: "The Indian toy market is growing rapidly with huge potential." },
    { icon: "PackageOpen", title: "Curated Product Range", desc: "A thoughtfully curated catalog across all ages, categories & price points." },
    { icon: "Headset", title: "End-to-End Support", desc: "Site selection, store setup, staff training, marketing & operations." },
    { icon: "IndianRupee", title: "Attractive Profitability", desc: "Healthy margins with strong repeat-purchase potential." },
    { icon: "Megaphone", title: "Marketing Support", desc: "Launch campaigns, social media & local marketing support." },
  ],
  models: [
    {
      name: "Signature Store",
      size: "1500 – 3000 sq.ft.",
      headerColor: "#1B1F5C",
      image: "https://customer-assets-v7afamib.emergentagent.net/job_appa-playtime/artifacts/0qzkkkkd_Signature%20Store.png",
      points: ["Flagship standalone experience store", "Ideal for high streets & prime locations", "Complete range with play zones"],
      investment: "₹40 Lakhs*",
    },
    {
      name: "Flagship Store – Mall",
      size: "800 – 1500 sq.ft.",
      headerColor: "#F79433",
      image: "https://customer-assets-v7afamib.emergentagent.net/job_appa-playtime/artifacts/vvwc1ect_Flagship%20Store%20-%20Mall.png",
      points: ["Premium in-mall store format", "High visibility & family footfall", "Wide range of toys & games"],
      investment: "₹25 Lakhs*",
    },
    {
      name: "Kiosk",
      size: "150 – 300 sq.ft.",
      headerColor: "#35C3C1",
      image: "https://customer-assets-v7afamib.emergentagent.net/job_appa-playtime/artifacts/yfip644z_Kiosk.png",
      points: ["Compact & affordable model", "Ideal for malls & retail spaces", "Quick setup & easy operation"],
      investment: "₹8 Lakhs*",
    },
  ],
  steps: [
    { icon: "Mail", num: "1. Enquiry", desc: "Submit your franchise\nenquiry form", color: "#35C3C1" },
    { icon: "Headset", num: "2. Discussion", desc: "We connect with you\n& understand your requirements", color: "#F79433" },
    { icon: "MapPin", num: "3. Location", desc: "Site evaluation &\nfeasibility analysis", color: "#35C3C1" },
    { icon: "FileText", num: "4. Agreement", desc: "Finalize terms &\nsign franchise agreement", color: "#F79433" },
    { icon: "Store", num: "5. Setup", desc: "Store setup, staff training\n& stock allocation", color: "#35C3C1" },
    { icon: "Rocket", num: "6. Launch", desc: "Grand launch & marketing\nsupport to grow your business", color: "#F79433" },
  ],
  testimonials: [
    { quote: "We're building Adhira & Appa Toys to be the most loved toy destination for Indian families — and our founding franchise partners will grow with us from day one.", name: "Team Adhira & Appa", role: "Our Founding Vision" },
    { quote: "Every store we design is a joyful, safe space where children explore, learn and play — not just shop.", name: "Team Adhira & Appa", role: "Our Store Philosophy" },
    { quote: "Early partners receive founding-partner advantages: prime territories, hands-on setup support and a real voice in shaping the brand.", name: "Team Adhira & Appa", role: "Founding Partner Programme" },
  ],
  stats: [
    { icon: "Store", value: "3", label: "Flexible Store Formats\nKiosk to Flagship", bg: "#FDF3DC", color: "#F79433" },
    { icon: "Users", value: "100%", label: "Founder-Led\nPartner Support", bg: "#DFF6F6", color: "#35C3C1" },
    { icon: "ChartNoAxesCombined", value: "Fast-Growing", label: "Indian Toy\nIndustry", bg: "#EFE7FB", color: "#8B5CF6" },
    { icon: "HandCoins", value: "Early-Bird", label: "Founding Partner\nBenefits", bg: "#FDE7EF", color: "#F0426A" },
  ],
  formPerks: [
    { icon: "Timer", title: "Quick Response", desc: "Within 24 Hours" },
    { icon: "Headset", title: "Expert Guidance", desc: "At Every Step" },
    { icon: "BadgeCheck", title: "EBG Group Venture", desc: "Built to Last" },
  ],
};
